import { render } from "./Errori.vue?vue&type=template&id=4dceb0c8"
import script from "./Errori.vue?vue&type=script&lang=js"
export * from "./Errori.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__